export default "__VITE_ASSET__0fe54bf4__"